import React, { lazy, memo } from 'react';
export function Problem() {
  return <section className="py-16 px-4 bg-[#EFE4CC]" data-id="element-226">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-227">
        {/* Intro Problem */}
        <div className="flex justify-center" data-id="element-228">
          <img src="https://cdn.magicpatterns.com/uploads/jzHFabjwXAnPu9HpTUxfoz/WhatsApp_Image_2026-05-05_at_8.38.46_PM.jpg" alt="Activá tu mente + recuerdos para toda la vida" loading="lazy" className="w-full max-w-2xl h-auto rounded-2xl shadow-lg border border-orange-200" data-id="element-229" />
        </div>

        {/* What happens in most families */}
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-orange-200 shadow-md space-y-6 text-lg text-slate-700" data-id="element-230">
          <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-231">
            Lo que pasa en la mayoría de las familias
          </h3>

          <p data-id="element-232">
            Algunos esperan a ver si mejora solo. Otros lo llevan al médico y
            les dicen "es la edad". Otros buscan en Google y se pierden entre
            estudios en inglés o apps que el adulto mayor nunca va a usar.
          </p>
          <p className="font-semibold text-slate-900" data-id="element-233">
            Y casi todos terminan haciendo nada. No por falta de amor, sino
            porque no saben qué hacer ni cómo.
          </p>
          <p data-id="element-234">
            Mientras tanto el adulto mayor sigue solo en casa, con la tele de
            fondo, sin nada que lo desafíe mentalmente.
          </p>
          <p className="text-teal-700 font-medium italic" data-id="element-235">
            Y el cerebro, como cualquier músculo que no se usa, se va apagando
            de a poco.
          </p>
        </div>

        {/* The real problem */}
        <div className="space-y-8" data-id="element-236">
          <h3 className="text-3xl font-bold text-slate-900 text-center mb-6" data-id="element-237">
            RESULTADOS 🧠
          </h3>

          <p className="text-lg md:text-xl text-center text-slate-700 mb-8" data-id="element-238">
            Con el uso constante podés:
          </p>

          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-239">
            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-240">
              <p className="text-lg font-semibold text-slate-900" data-id="element-241">
                Sentirte más ágil
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-242">
              <p className="text-lg font-semibold text-slate-900" data-id="element-243">
                Mejorar la memoria diaria
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-244">
              <p className="text-lg font-semibold text-slate-900" data-id="element-245">
                Tener más concentración
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-246">
              <p className="text-lg font-semibold text-slate-900" data-id="element-247">
                Reducir olvidos simples
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}